<template>
    <div class="pt-8">
        <FilterForm 
            :filter="filter" 
            @get-users-list="getUsersList()" 
            @clear-filter-form="clearFilterForm()" 
        />
        <UsersTable 
            :users="users" 
            :paginator="paginator" 
            :pageSize="pageSize" 
            @get-users-list="getUsersList()" 
            @change-page="changePage($event)" 
            
        />
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import FilterForm from '../components/FilterForm.vue'
import UsersTable from '../components/UsersTable.vue'
export default {
    computed: {
        ...mapState('auth', ['user'])
    },
    data(){
        return{
            users: [],
            filter: {
                nombre: "",
                email: "",
                telefono: "",
            },
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
        }
    },
    components: {
        FilterForm,
        UsersTable
    },
    created(){
        this.getUsersList();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getUsersList(){
            this.pageOptions = {
                pageNumber: this.paginator.page, 
                pageSize:   this.paginator.pageSize,
                nombre:     this.filter.nombre,
                email:      this.filter.email,
                telefono:   this.filter.telefono
            }
            this.setLoading(true)
            await this.$conectar.post('/admin/users/get-users-list', this.pageOptions)
            .then(response =>{
                this.users = response.data.data.userList;
                this.paginator.totalPage = response.data.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getUsersList();
        },
        clearFilterForm(){
            this.filter.nombre = "";
            this.filter.email = "";
            this.filter.telefono = "";
            this.paginator.pageSize = 10;
        }
    }
}
</script>